import React, {useContext, useState} from 'react';
import Button from "@mui/material/Button";
import ConfirmModal from "../../terraforming/utils/Modal";

export const MainTurnState = ({state, userId, setConfirmAction}) => {

    const [actionX, setActionX] = useState(false);
    const [selectedAction, setSelectedAction] = useState(undefined);
    const [nbXToken, setNbXToken] = useState(0);

    const getLowestOkAction = (actionClass) => {
        return state.actions[userId].filter(a => a.actionCardNames === actionClass && a.ok && a.class === "action.ActionSelectActionCard").sort((a, b) => a.xToken - b.xToken)[0];
    }

    return <div>
        <h1>
            Choisissez votre action :
        </h1>
        <div>
            {
                state.actions[userId].filter(a => (!actionX && a.xToken === 0) || (actionX && a.class === "action.ActionResetActionCard")).map(a =>
                    <div key={a.actionCardNames}>
                        <div
                            style={{
                                width: '100%',
                                backgroundColor: "#2a2d4a",
                                borderRadius: "8px",
                                display: "flex",
                                marginBottom: "8px",
                                padding: "10px 15px",
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                transition: 'all 0.2s ease',
                                boxSizing: 'border-box',
                                height: "8vh"
                            }}>


                            <img style={{height: "60%", marginRight: "12px"}}
                                 src={"/public/arknova/actions/icon_action_" + a.actionCardNames.toLowerCase() + ".png"}
                                 alt={"img " + a.actionCardNames}
                            />
                            <div style={{flex: 1, fontSize: "16px"}}>
                                {a.actionCardNames}
                            </div>
                            <div>
                                <Button
                                    variant={"contained"}
                                    disabled={(!getLowestOkAction(a.actionCardNames) && !actionX) || selectedAction === a}
                                    onClick={() => {
                                        if (!actionX && state.actions[userId].some(b => b.xToken > 0 && b.actionCardNames === a.actionCardNames && b.ok)) {
                                            setNbXToken(getLowestOkAction(a.actionCardNames).xToken);
                                            setSelectedAction(a);
                                        } else {
                                            setConfirmAction({
                                                action: a,
                                                message: actionX ? "Remettre " + a.actionCardNames + " en 1 et gagner un jeton X ?" : "Êtes-vous sûr de vouloir effectuer " + a.actionCardNames + " en " + a.basicPosition + " ?"
                                            })
                                        }
                                    }
                                    }
                                    sx={{minWidth: '80px'}}
                                >
                                    {actionX ? "Jeton X" : "Choisir"}
                                </Button>
                            </div>
                        </div>
                        {
                            selectedAction === a && <div style={{}}>
                                Jouer l'action avec des jetons X ?
                                <br/>
                                <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginTop: "20px"
                                }}>
                                    <div style={{flex: 1}}>
                                        <Button variant="contained" disabled={!state.actions[userId].some(b => b.xToken === nbXToken - 1 && b.actionCardNames === a.actionCardNames && b.ok)}
                                                onClick={() => setNbXToken(nb => nb - 1)}>-</Button>
                                        {nbXToken}
                                        <Button variant="contained" disabled={!state.actions[userId].some(b => b.xToken === nbXToken + 1 && b.actionCardNames === a.actionCardNames && b.ok)}
                                                onClick={() => setNbXToken(nb => nb + 1)}>+</Button>
                                    </div>
                                    <div>
                                        <Button variant={"contained"} onClick={() => setConfirmAction({
                                            action: {...a, xToken: nbXToken},
                                            message: "Êtes-vous sûr de vouloir effectuer " + a.actionCardNames + " en " + (a.basicPosition + nbXToken) + " ?"
                                        })}>
                                            Confirmer
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                )
            }
        </div>
        {
            state.actions[userId].some(a => a.class === "action.ActionResetActionCard") && <div style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "20px"
            }}>
                <div style={{flex: 3, fontSize: "16px"}}>
                    Remettre une carte d'action en 1 pour gagner un jeton X ?
                </div>
                <Button
                    variant={"contained"}
                    onClick={() => {
                        setSelectedAction(undefined);
                        setActionX(x => !x);
                    }}
                >
                    {actionX ? "Annuler" : "Action Jeton X"}
                </Button>
            </div>
        }
    </div>


}
export default MainTurnState;
